// @flow

import React from 'react';

type onSettingChangeFn = (prefs: {[string]: string}) => void;

type SettingsHandlerContextType = {
  onSettingChange: onSettingChangeFn,
};
export const SettingsHandlerContext = React.createContext<SettingsHandlerContextType>(
  {},
);

export const useSettingsSelectorHandler = (): SettingsHandlerContextType => {
  return React.useContext(SettingsHandlerContext);
};
